// Утилита для обработки ошибок API
export const handleApiError = (error, defaultMessage = "Произошла ошибка") => {
  if (error.response) {
    // Сервер вернул ответ с ошибкой
    const status = error.response.status;
    const data = error.response.data;
    
    if (status === 400) {
      // Ошибка валидации или бизнес-логики
      return typeof data === 'string' ? data : defaultMessage;
    } else if (status === 401) {
      return "Необходима авторизация";
    } else if (status === 403) {
      return "Недостаточно прав для выполнения операции";
    } else if (status === 404) {
      return "Запрашиваемый ресурс не найден";
    } else if (status >= 500) {
      return "Ошибка сервера. Попробуйте позже";
    }
  } else if (error.request) {
    // Запрос был отправлен, но ответ не получен
    return "Ошибка сети. Проверьте подключение к интернету";
  } else {
    // Ошибка при настройке запроса
    return defaultMessage;
  }
  
  return defaultMessage;
};

// Функция для отображения ошибок пользователю
export const showError = (message, duration = 5000) => {
  // Создаем элемент для отображения ошибки
  const errorDiv = document.createElement('div');
  errorDiv.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #f44336;
    color: white;
    padding: 16px;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    z-index: 10000;
    max-width: 400px;
    word-wrap: break-word;
  `;
  errorDiv.textContent = message;
  
  document.body.appendChild(errorDiv);
  
  // Удаляем через указанное время
  setTimeout(() => {
    if (errorDiv.parentNode) {
      errorDiv.parentNode.removeChild(errorDiv);
    }
  }, duration);
}; 